import React, {Component} from 'react';
import './style/sortlist.css';

class SortList extends Component {
    constructor(props) {
        super(props);
        this.title = props.title;
        this.name = props.name;
        this.name_additional = props.name_additional;
        this.placeholder = props.placeholder;
        this.placeholder_additional = props.placeholder_additional;
        this.removeItem = this.removeItem.bind(this);
        this.addItem = this.addItem.bind(this);
        this.onChangeGroupName = this.onChangeGroupName.bind(this);
        this.onChangeGroupId = this.onChangeGroupId.bind(this);
        this.changePosition = this.changePosition.bind(this);
        this.state = {
            groupName: '',
            groupId: '',
            btnDisabled: true,
        };
    }

    onChange(data) {
        this.props.onChange({
            target: data
        });
    }
    onCreate() {
        this.props.onCreate({
            target: {
                groupName: this.state.groupName,
                groupId: this.state.groupId,
            }
        });
    }

    onDelete(groupID) {
        this.props.onDelete({
            target: {
                groupId: groupID,
            }
        });
    }

    onChangeGroupName(e) {
        this.setState({
            ...this.state,
            groupName: e.target.value
        });
    }

    onChangeGroupId(e) {
        this.setState({
            ...this.state,
            groupId: e.target.value
        });
    }

    checkData () {
        const btnCurrentState = (!this.state.groupName || !this.state.groupId);

        if(this.state.btnDisabled !== btnCurrentState){
            this.setState({
                ...this.state,
                btnDisabled: btnCurrentState,
            });
        }
    }

    removeItem(e, key) {
        e.preventDefault();
        this.onDelete(key);
    }

    addItem(e) {
        e.preventDefault();
        if (this.state.groupName && this.props.value.indexOf(this.state.groupName) === -1) {
            this.setState({
                ...this.state,
                btnDisabled: true,
                groupName: e.target.value,
                groupId: e.target.value
            });
            this.onCreate();
        }
    }
    array_move (incomingArr, old_index, new_index) {
        const arr = [].concat(incomingArr);
        if (new_index >= arr.length) {
            var k = new_index - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
        return arr; // for testing
    };

    changePosition (e, direction, id) {
        e.preventDefault();
        console.log(this.props.value, direction, id);
        let currentArrayItem;

        this.props.value.forEach((item) => {
            if(item.id === id){
                currentArrayItem = item;
            }
        });
        let currentIndex = this.props.value.indexOf(currentArrayItem);

        let newArr = this.props.value;
        if(direction === 'up') {
            if(currentIndex > 0){
                newArr = this.array_move(this.props.value, currentIndex, currentIndex-1);
            }
        } else {
            if(currentIndex < this.props.value.length - 1)
            newArr = this.array_move(this.props.value, currentIndex, currentIndex+1);
        }

        this.onChange(newArr);
    }

    render() {
        this.checkData();
        console.log(this.props);
        return (
            <div className="fieldWrapper">
                <label htmlFor={this.name}>
                    {this.title || this.name}
                </label>
                <div className="list" name={this.name}>
                    <div className="line selectsWrapper">
                        <div className={'inputSortWrapper'}>
                        <input
                            type="text"
                            placeholder={this.placeholder}
                            id={this.name}
                            name={this.name}
                            value={this.state.groupName}
                            onChange={this.onChangeGroupName}
                        />
                        <input
                            type="text"
                            placeholder={this.placeholder_additional}
                            id={this.name_additional}
                            name={this.name_additional}
                            value={this.state.groupId}
                            onChange={this.onChangeGroupId}
                        />
                        </div>
                        <button className="addItem icon" onClick={this.addItem}
                                disabled={this.state.btnDisabled}> </button>
                    </div>
                    {(this.props.value.length) ? this.props.value.map(
                        (fieldKey, i) => <div className="line" key={i}>
                            <div className='val-value'>{i+1}. {fieldKey.name}</div>
                            <div className="sort">
                                <a className='sortUp' onClick={(e)=> this.changePosition(e, 'up', fieldKey.id)} disabled={i === 0}></a>
                                <a className='sortDown' onClick={(e)=> this.changePosition(e, 'down', fieldKey.id)} disabled={i === this.props.value.length-1}></a>
                            </div>
                            <button className="removeItem icon" onClick={(e) => this.removeItem(e, fieldKey.id)}></button>
                        </div>
                    ) : <span></span>}
                    <div className="line">
                    <div className='val-value'>Priorité par défaut</div>
                        <div className="sort">
                            <a className='sortUp' onClick={(e)=> e.preventDefault()} disabled></a>
                            <a className='sortDown' onClick={(e)=> e.preventDefault()} disabled></a>
                        </div>
                        <button className="removeItem icon" onClick={(e) => e.preventDefault()} disabled></button>
                    </div>
                </div>
            </div>
        );
    }
}


export default SortList;
